import { ShareService } from "./news-detail";

new ShareService(
    document.querySelector(".news-footer__share"),
    document.querySelector(".news-footer__print")
);